import * as React from 'react';
import { useAccountPositionsHistoryHisMvtOperDate } from '../../hooks';
import { ActorApiDateDisplay } from '../../../../../../components/display/date';

export const AccountsPositionsHistoryHisMvtOperDate = (props: {
  format: string,
  formatMq?: boolean,
}) => {
  const {
    format,
    formatMq,
  } = props;
  const {
    data,
    isLoading,
    error,
  } = useAccountPositionsHistoryHisMvtOperDate();
  return (
    <ActorApiDateDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      format={format}
      formatMq={formatMq}
    />
  );
};
